<template>
  <div id="homepage-mypage-community-info-template">
    <ul class="divided-tabs tab-count--4 clearfix" role="tablist" id="buttons-tab">
      <li class="divided-tab active" role="presentation">
        <a class="divided-tab__link" href="#decsList1" aria-controls="decsList${moduleItemId}-${status.count}"
           role="tab" data-toggle="tab">
          커뮤니티 개요<i class="fa fa-caret-down divided-tab__link__arrow"></i>
        </a>
      </li>

      <li class="divided-tab" role="presentation">
        <a class="divided-tab__link" href="#decsList2" aria-controls="decsList${moduleItemId}-${status.count}"
           role="tab" data-toggle="tab">
          커뮤니티 정보<i class="fa fa-caret-down divided-tab__link__arrow"></i>
        </a>
      </li>

      <li class="divided-tab" role="presentation">
        <a class="divided-tab__link" href="#decsList4" aria-controls="decsList${moduleItemId}-${status.count}"
           role="tab" data-toggle="tab">
          커뮤니티 운영자<i class="fa fa-caret-down divided-tab__link__arrow"></i>
        </a>
      </li>
      
      <li class="divided-tab" role="presentation">
      </li>

    </ul>
    <div class="divided-tabpanels tab-content">
      <div role="tabpanel" class="tab-pane active"
           id="decsList1">
        <div class="lg-label-form-group">
          <label class="lg-label">커뮤니티 개요</label>

          <div class="inline-input-group clearfix">
            <label class="inline-input__label">커뮤니티 명</label>
            <p class="progress__only-text">{{communityInfo.name}}</p>
          </div>

          <div class="inline-input-group clearfix">
            <label class="inline-input__label">소개글</label>
            <textarea v-model.trim="changeDesc" class="input__textarea input__textarea--thin" ref="desc" placeholder="최대 200자까지 입력가능합니다." v-bind:readonly="member.loginid === currentRepresentation ? false : true" maxlength="200" title="최대 200자까지 입력가능합니다."></textarea>
          </div>

          <div class="inline-input-group clearfix">
            <label class="inline-input__label">회원수</label>
            <input type="text" ref="changeMemberCount" v-model.trim="changeMemberCount" class="input__text" placeholder="숫자로만 입력해주세요. 예) 10명 일경우 10" v-bind:readonly="member.loginid === currentRepresentation ? false : true" title="숫자로만 입력해주세요. 예) 10명 일경우 10">
          </div>

          <div class="inline-input-group clearfix">
            <label class="inline-input__label">커뮤니티 권한</label>
            <p class="progress__only-text">{{communityInfo.communityPlus ? '커뮤니티 플러스' : '일반'}}</p>
          </div>

          <div class="inline-input-group clearfix">
            <label class="inline-input__label">대표이미지</label>
            <p class="guide-text">277 * 208 px에 최적화 되어 있습니다.</p>
            <input type="file" ref="changeImgUrl" id="changeImgUrl" accept="image/gif, image/jpeg, image/png"  class="inline-input__file" v-on:change="imgUrlChange('changeImgUrl')" v-if="member.loginid === currentRepresentation" title="changeImgUrl 첨부파일 선택">
            <div class="thumbnail-img-ex">
              <div class="embed-responsive embed-responsive-4by3 background-image" v-if="communityInfo.imgUrl" :style="`background-image: url('${communityInfo.imgUrl}');`"></div>
              <div class="embed-responsive embed-responsive-4by3 background-image" v-else :style="`background-image: url('/images/img/communityDefault.jpg');`"></div>
            </div>
          </div>
        </div>

        <div class="lg-label-form-group" v-if="communityInfo.applicant">
          <label class="lg-label">커뮤니티신청자</label>
          <div class="form-box-gray">
            <div class="inline-readonly-group clearfix">
              <label class="inline-input__label">이름</label>
              <p class="progress__only-text">{{communityInfo.applicant.name}}</p>
            </div>

            <div class="inline-readonly-group clearfix">
              <label class="inline-input__label">생년월일</label>
              <p class="progress__only-text">{{communityInfo.applicant.birthdate}}</p>
            </div>

            <div class="inline-readonly-group clearfix">
              <label class="inline-input__label">연락처</label>
              <p class="progress__only-text">{{communityInfo.applicant.phone}}</p>
            </div>

            <div class="inline-readonly-group clearfix">
              <label class="inline-input__label">이메일</label>
              <p class="progress__only-text">{{communityInfo.applicant.email}}</p>
            </div>
            <div class="inline-readonly-group clearfix">
              <label class="inline-input__label">주소</label>
              <p class="progress__only-text">{{communityInfo.applicant.addrCity}} {{communityInfo.applicant.addrGu}}</p>
            </div>
          </div>
        </div>

        <div class="">
          <button @click="changeApply" type="button" class="form-submit__btn btn--blue-line" v-if="(member.loginid === currentRepresentation)">승인요청하기</button>
        </div>
      </div>

      <div role="tabpanel" class="tab-pane"
           id="decsList2">
        <div class="lg-label-form-group">
          <label class="lg-label">커뮤니티 한마디</label>

          <div class="result-group-with-btn clearfix">
            <div class="grid-3">
              <p class="progress__only-text">예) 총무 김무자</p>
            </div>
            <div class="grid-33">
              <p class="progress__only-text">예) 지치지 않는 열정의 프로펠러</p>
            </div>
          </div>

          <div class="input-group-with-btn clearfix">
            <div class="grid-3 p-r-20">
              <input type="text" v-model.trim="commentsWriter" class="input__text" placeholder="입력해주세요." ref="commentsWriter" title="입력해주세요.">
            </div>
            <div class="grid-33">
              <input type="text" v-model.trim="commentsInput" class="input__text" placeholder="입력해주세요." ref="commentsInput" title="입력해주세요.">
            </div>
            <button type="button" @click="addComments" class="input-btn btn--gray">추가</button>
          </div>

          <ul class="input-added-list" v-if="communityInfo.comments && communityInfo.comments.length > 0">
            <li v-for="(comment, idx) in communityInfo.comments">
              <div class="result-group-with-btn clearfix">
                <div class="grid-3">
                  <p class="progress__only-text">{{comment.writer}}</p>
                </div>
                <div class="grid-33 border-l l-m-p-10">
                  <p class="progress__only-text">{{comment.comment}}</p>
                </div>
                <button type="button" @click="removeComments(idx)" class="input-btn btn--gray">삭제</button>
              </div>
            </li>
          </ul>
        </div>

        <div class="lg-label-form-group">
          <label class="lg-label">배너 등록</label>

          <div class="result-group-with-btn clearfix">
            <div class="grid-3">
              <p class="progress__only-text">예) 총무 김무자</p>
            </div>
            <div class="grid-3">
              <p class="progress__only-text">예) 꽃동네 봉사활동</p>
            </div>
            <div class="grid-3">
              <p class="progress__only-text">http://www.naver.com</p>
            </div>
          </div>

          <div class="input-group-with-btn clearfix">
            <div class="grid-3">
              <input type="file" ref="bannerImg" id="bannerImg" accept="image/gif, image/jpeg, image/png"  v-on:change="imgUrlChange('bannerImg')" class="inline-input__file" title="bannerImg 첨부파일 선택">
            </div>
            <div class="grid-3 p-r-20">
              <input type="text" v-model.trim="title" ref="title" class="input__text"  placeholder="최대 30자까지 입력가능합니다." title="최대 30자까지 입력가능합니다.">
            </div>
            <div class="grid-3">
              <input type="text" v-model.trim="linkUrl" ref="linkUrl" class="input__text" placeholder="예) http://www.naver.com / 최대 50자까지 입력가능합니다." title="예) http://www.naver.com / 최대 50자까지 입력가능합니다.">
            </div>
            <button type="button" @click="addBanner" class="input-btn btn--gray">추가</button>
            <div class="helper-text xs-text">*확장자 jpg, jpeg, png, gif<br> 파일만 올려주세요.(2mb 이하)<br>1130*204px</div>
          </div>

          <ul class="input-added-list" v-if="communityInfo.banners && communityInfo.banners.length > 0">
            <li v-for="(banner, idx) in communityInfo.banners">
              <div class="result-group-with-btn clearfix">
                <div class="grid-3">
                  <div class="preview-img-wrapper">
                    <img :src="banner.imageUrl" alt="배너이미지">
                  </div>
                </div>
                <div class="grid-3 border-l l-m-p-10">
                  <p class="progress__only-text">{{banner.title}}</p>
                </div>
                <div class="grid-3">
                  <p class="progress__only-text">{{banner.linkUrl}}</p>
                </div>
                <button type="button" @click="removeBanner(idx)" class="input-btn btn--gray">삭제</button>
              </div>
            </li>

          </ul>
        </div>

        <div class="lg-label-form-group">
          <label class="lg-label">커뮤니티 연락처</label>
          <div class="inline-input-group clearfix">
            <label class="inline-input__label">이메일</label>
            <input type="text" ref="email" v-model.trim="communityInfo.email" class="input__text" placeholder="입력해주세요." title="입력해주세요.">
          </div>

          <div class="inline-input-group clearfix">
            <label class="inline-input__label">홈페이지 url</label>
            <input type="text" v-model.trim="communityInfo.homepageUrl" class="input__text" placeholder="http://www.naver.com" title="http://www.naver.com">
          </div>

          <div class="inline-input-group clearfix">
            <label class="inline-input__label">sns url</label>
            <input type="text" v-model.trim="communityInfo.snsUrl" class="input__text" placeholder="http://facebook.com" title="http://facebook.com">
          </div>
        </div>

        <div class="">
          <button @click="modifyInfo" type="button" class="form-submit__btn btn--blue-line">수정하기</button>
        </div>
      </div>

      <div role="tabpanel" class="tab-pane "
           id="decsList4">
        <h4 class="margin-bottom-40" v-if="(member.loginid !== currentRepresentation)">커뮤니티 대표만 이용 가능한 메뉴입니다.</h4>
        <div class="lg-label-form-group" v-if="(member.loginid === currentRepresentation)">
          <label class="lg-label">커뮤니티 운영자</label>
          <div class="form-box-gray"  v-if="(member.loginid === currentRepresentation)">
            <div class="inline-input-group clearfix">
              <label class="inline-input__label">이름</label>
              <input type="text" ref="operatorName" v-model.trim="operator.name" class="input__text"  placeholder="최대 30자까지 입력가능합니다." title="최대 30자까지 입력가능합니다.">
            </div>

            <div class="inline-input-group clearfix">
              <label class="inline-input__label">회원 ID</label>
              <input type="text" ref="operatorLoginid" v-model.trim="operator.loginid" class="input__text"  placeholder="최대 30자까지 입력가능합니다." title="최대 30자까지 입력가능합니다.">
            </div>

            <div class="inline-input-group clearfix">
              <label class="inline-input__label">연락처</label>
              <input type="number" ref="operatorPhone" v-model.trim="operator.phone" class="input__text" placeholder="숫자만 입력해주세요." title="숫자만 입력해주세요.">
            </div>
            <div class="text-right">
              <button type="button" class="community-add-btn btn--gray" @click="addOperator">추가</button>
            </div>
          </div>
        </div>
        <template v-if="(communityInfo.operators && communityInfo.operators.length > 0) && (member.loginid === currentRepresentation)">
          <div class="lg-label-form-group" v-for="(operator, idx) in communityInfo.operators">
            <div class="form-box-gray">
              <div class="inline-input-group clearfix">
                <label class="inline-input__label">이름</label>
                <input type="text" :value="operator.name" class="input__text" placeholder="입력해주세요." readonly title="입력해주세요.">
              </div>

              <div class="inline-input-group clearfix">
                <label class="inline-input__label">회원 ID</label>
                <input type="text" :value="operator.loginid" class="input__text" placeholder="입력해주세요." readonly title="입력해주세요.">
              </div>

              <div class="inline-input-group clearfix">
                <label class="inline-input__label">연락처</label>
                <input type="text" :value="operator.phone" class="input__text" placeholder="입력해주세요." readonly title="입력해주세요.">
              </div>

              <div class="inline-input-group clearfix" v-if="operator.status.key === 'APPROVAL'">
                <label class="inline-input__label">이메일</label>
                <input type="text" :value="operator.email" class="input__text" placeholder="입력해주세요." readonly title="입력해주세요.">
              </div>

              <div class="inline-input-group clearfix" v-if="operator.status.key === 'APPROVAL'">
                <label class="inline-input__label">주소</label>
                <div class="f-gutter-10">
                  <div class="f-gutter-10__li grid-2">
                    <input type="text" v-model.trim="operator.addrCity" class="input__text" placeholder="시" readonly title="시">
                  </div>
                  <div class="f-gutter-10__li grid-2">
                    <input type="text" v-model.trim="operator.addrGu" class="input__text" placeholder="구" readonly title="구">
                  </div>
                </div>
              </div>
              <div class="inline-input-group clearfix">
                <label class="inline-input__label">승인</label>
                <p class="progress__only-text">{{status[operator.status]}}</p>
              </div>
              <div class="text-right">
                <button type="button" @click="removeOperator(idx, operator.id)" class="community-add-btn btn--gray"
                        v-if="(operator.loginid !== member.loginid) || (member.loginid === currentRepresentation)">삭제
                </button>
              </div>
            </div>
          </div>
        </template>
        <div class="lg-label-form-group" v-if="(member.loginid === currentRepresentation)">
          <div class="inline-input-group clearfix">
            <label class="inline-input__label">대표자</label>
            <select v-model.trim="representation" class="form-control" title=" 선택">
              <option v-for="admin in administrator" :value="admin.loginid">{{admin.name}}</option>
            </select>
          </div>
          <div class="inline-input-group clearfix">
            <label class="inline-input__label">총무</label>
            <select v-model.trim="operatorManager" class="form-control" title=" 선택">
              <option v-for="admin in administrator" :value="admin.loginid">{{admin.name}}</option>
            </select>
          </div>
        </div>
        <div class="">
          <button type="button" @click="modifyManager" class="form-submit__btn btn--blue-line"  v-if="(member.loginid === currentRepresentation)">대표, 총무 변경</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Axios from 'axios';
  import CommonFn from '../../common-functions/commonFuntions';

  const commonFn = new CommonFn();

  const status = {
    REQUEST: '요청',
    APPROVAL: '승인',
    REJECT: '반려, 거부',
    DISMISS: '해고',
    INIT: '커뮤니티 신청중',
    NONE: '존재하지 않는 사람',
  };

  export default {
    name: 'homepage-mypage-community-info-template',
    props: ['member'],
    data() {
      return {
        status,
        selectedId: '',
        communityInfo: {},
        changeDesc: '',
        changeMemberCount: '',
        changeImgUrl: '',
        manager: [],
        administrator: [],
        representation: '',
        currentRepresentation: '',
        operatorManager: '',
        currentOperatorManager: '',
        name: '',
        communityMember: {},
        operator: {},
        title: '',
        linkUrl: '',
        bannerImg: '',
        commentsInput: '',
        commentsWriter: '',
        isApproval: '',
      };
    },
    methods: {
      imgUrlChange(id) {
        const formData = new FormData();
        formData.append('foo', 'bar');
        formData.append('file', document.getElementById(`${id}`).files[0]);
        const Config = {
          /* eslint-disable */
          headers: { 'Content-Type': `multipart/form-data; boundary=${formData._boundary}` },
          /* eslint-enable */
        };
        Axios.post('/api/file-uploads', formData, Config).then((res) => {
          if (id === 'changeImgUrl') this[id] = res.data.filename;
          else if (id === 'bannerImg') this.bannerImg = res.data.filename;
        }).catch((e) => {
          alert(e.response.data.msg);
        });
      },
      getCommunityInfo() {
        Axios.get(`/api/communities/${this.selectedId}`).then((res) => {
          this.communityInfo = res.data || [];
          this.changeDesc = this.communityInfo.desc;
          this.changeMemberCount = this.communityInfo.memberCount;
          this.changeImgUrl = this.communityInfo.imgUrl;
          this.communityInfo.applicant.addrCity = this.communityInfo.applicant.addr.split(' ')[0];
          this.communityInfo.applicant.addrGu = this.communityInfo.applicant.addr.split(' ')[1];
          this.manager = this.communityInfo.operators;
          this.manager.forEach((admin) => {
            if (admin.status === 'APPROVAL') {
              this.administrator.push(admin);
            }
          });
          this.currentRepresentation = this.communityInfo.representation.loginid;
          this.currentOperatorManager = this.communityInfo.manager.loginid;
          this.representation = this.communityInfo.representation.loginid;
          this.operatorManager = this.communityInfo.manager.loginid;
          this.isApproval = this.communityInfo.status;
          /* alert(this.isApproval); */
        }).catch((e) => {
          alert(e.response.data.msg);
        });
      },
      getParams() {
        const url = window.location.search.substring(1);
        this.selectedId = commonFn.parseQueryString(url).id;
      },
      changeApply() {
        if (this.changeDesc && this.changeMemberCount) {
          const Params = {
            changeDesc: this.changeDesc,
            changeMemberCount: this.changeMemberCount,
            changeImgUrl: this.changeImgUrl,
          };
          Axios.put(`/api/communities/${this.selectedId}/request-outline`,
            Params,
            { params: { org: this.communityInfo.org } }).then(() => {
            alert('변경내용을 승인요청하였습니다.');
          }).catch((e) => {
            alert(e.response.data.msg);
          });
        } else if (!this.changeDesc) {
          alert('커뮤니티 소개글을 입력해 주세요.');
          this.$refs.changeDesc.focus();
        } else if (this.changeDesc.length > 200) {
          alert('소개글을 200자 이하로 입력해 주세요.');
          this.$refs.changeDesc.focus();
        } else if (!this.changeMemberCount) {
          alert('커뮤니티 회원수를 입력해 주세요.');
          this.$refs.changeMemberCount.focus();
        } else if (this.changeMemberCount > 0) {
          alert('커뮤니티 회원수를 확인해주세요.');
          this.$refs.changeMemberCount.focus();
        }
      },
      modifyInfo() {
        const Params = {
          comments: this.communityInfo.comments,
          banners: this.communityInfo.banners,
          email: this.communityInfo.email,
          homepageUrl: this.communityInfo.homepageUrl,
          snsUrl: this.communityInfo.snsUrl,
        };
        Axios.put(`/api/communities/${this.selectedId}/info`,
          Params,
          { params: { org: this.communityInfo.org } }).then(() => {
          alert('커뮤니티 정보가 수정되었습니다.');
        }).catch((e) => {
          alert(e.response.data.msg);
        });
      },
      addComments() {
        if (this.commentsInput !== '' && this.commentsWriter !== '') {
          this.communityInfo.comments.push({
            writer: this.commentsWriter,
            comment: this.commentsInput,
          });
          this.commentsWriter = '';
          this.commentsInput = '';
        } else if (!this.commentsWriter) {
          alert('빈칸을 입력해 주세요.');
          this.$refs.commentsWriter.focus();
        } else if (!this.commentsInput) {
          alert('한마디를 입력해 주세요.');
          this.$refs.commentsInput.focus();
        }
      },
      removeComments(idx) {
        const result = window.confirm('정말 삭제하시겠습니까?');
        if (result) {
          this.communityInfo.comments.splice(idx, 1);
        }
      },
      addBanner() {
        if (this.title !== '' && this.bannerImg !== '' && this.linkUrl !== '') {
          this.communityInfo.banners.push({
            title: this.title,
            imageUrl: this.bannerImg,
            linkUrl: this.linkUrl,
          });
          document.getElementById('bannerImg').value = '';
          this.title = '';
          this.bannerImg = '';
          this.linkUrl = '';
        } else if (!this.bannerImg) {
          alert('배너 이미지를 추가해 주세요.');
          this.$refs.bannerImg.focus();
        } else if (!this.title) {
          alert('배너 타이틀을 입력해 주세요.');
          this.$refs.title.focus();
        } else if (!this.linkUrl) {
          alert('배너 링크를 입력해 주세요.');
          this.$refs.linkUrl.focus();
        }
      },
      removeBanner(idx) {
        const result = window.confirm('정말 삭제하시겠습니까?');
        if (result) {
          this.communityInfo.banners.splice(idx, 1);
        }
      },
      addMember() {
        if (!this.communityMember.name) {
          alert('구성원 이름을 입력해 주세요.');
          this.$refs.communityMemberName.focus();
        } else if (!this.communityMember.birthdate) {
          alert('구성원 생년월일을 입력해 주세요.');
          this.$refs.communityMemberBirthDate.focus();
        } else if (this.communityMember.birthdate.length !== 6) {
          alert('구성원 생년월일을 확인해 주세요.');
          this.$refs.communityMemberBirthDate.focus();
        } else if (!this.communityMember.phone1) {
          alert('구성원 연락처를 입력해 주세요.');
          this.$refs.communityMemberPhone1.focus();
        } else if (!this.communityMember.phone2) {
          alert('구성원 연락처를 입력해 주세요.');
          this.$refs.communityMemberPhone2.focus();
        } else if (!this.communityMember.phone3) {
          alert('구성원 연락처를 입력해 주세요.');
          this.$refs.communityMemberPhone3.focus();
        } else if (!this.communityMember.addrCity) {
          alert('구성원 주소(시)를 입력해 주세요.');
          this.$refs.communityMemberAddrCity.focus();
        } else if (!this.communityMember.addrGu) {
          alert('구성원 주소(구)를 입력해 주세요.');
          this.$refs.communityMemberAddrGu.focus();
        } else if (!this.communityMember.email) {
          alert('구성원 이메일을 입력해 주세요.');
          this.$refs.communityMemberEmail.focus();
        } else {
          const Params = {
            name: this.communityMember.name,
            birthdate: this.communityMember.birthdate,
            phone1: this.communityMember.phone1,
            phone2: this.communityMember.phone2,
            phone3: this.communityMember.phone3,
            email: this.communityMember.email,
            addrCity: this.communityMember.addrCity,
            addrGu: this.communityMember.addrGu,
            role: this.communityMember.role,
          };
          Axios.post(`/api/communities/${this.selectedId}/members`,
            Params,
            { params: { org: this.communityInfo.org },
            }).then((res) => {
            alert('추가되었습니다.');
            this.communityInfo.members.push({
              id: res.data.id,
              name: this.communityMember.name,
              birthdate: this.communityMember.birthdate,
              phone1: this.communityMember.phone1,
              phone2: this.communityMember.phone2,
              phone3: this.communityMember.phone3,
              email: this.communityMember.email,
              addrCity: this.communityMember.addrCity,
              addrGu: this.communityMember.addrGu,
              role: this.communityMember.role,
            });
            this.communityMember.name = '';
            this.communityMember.birthdate = '';
            this.communityMember.phone1 = '';
            this.communityMember.phone2 = '';
            this.communityMember.phone3 = '';
            this.communityMember.email = '';
            this.communityMember.addrCity = '';
            this.communityMember.addrGu = '';
            this.communityMember.role = '';
          }).catch((e) => {
            alert(e.response.data.msg);
          });
        }
      },
      removeMember(idx, id) {
        const result = window.confirm('정말 삭제하시겠습니까?');
        if (result) {
          Axios.delete(`/api/communities/${this.selectedId}/members/${id}`,
            { params: { org: this.communityInfo.org },
            }).then(() => {
            alert('구성원이 삭제되었습니다.');
            this.communityInfo.members.splice(idx, 1);
          }).catch((e) => {
            alert(e.response.data.msg);
          });
        }
      },
      addOperator() {
        const Params = {
          name: this.operator.name,
          loginid: this.operator.loginid,
          phone: this.operator.phone,
        };
        if ((this.operator.name) && (this.operator.loginid) && (this.operator.phone)) {
          Axios.post(`/api/communities/${this.selectedId}/operators`,
            Params, { params: { org: this.communityInfo.org } }).then((res) => {
            alert('추가되었습니다.');
            this.communityInfo.operators.push({
              id: res.data.id,
              name: this.operator.name,
              loginid: this.operator.loginid,
              phone: this.operator.phone,
              status: 'REQUEST',
            });
            this.operator.name = '';
            this.operator.loginid = '';
            this.operator.phone = '';
          }).catch((e) => {
            alert(e.response.data.msg);
          });
        } else if (!this.operator.name) {
          alert('운영자 이름을 입력해 주세요.');
          this.$refs.operatorName.focus();
        } else if (!this.operator.loginid) {
          alert('운영자 아이디를 입력해 주세요.');
          this.$refs.operatorLoginid.focus();
        } else if (!this.operator.phone) {
          alert('운영자 연락처를 입력해 주세요.');
          this.$refs.operatorPhone.focus();
        }
      },
      removeOperator(idx, id) {
        const result = window.confirm('정말 삭제하시겠습니까?');
        if (result) {
          Axios.delete(`/api/communities/${this.selectedId}/operators/${id}`,
            {
              params: { org: this.communityInfo.org },
            }).then(() => {
            this.communityInfo.operators.splice(idx, 1);
          }).catch((e) => {
            alert(e.response.data.msg);
          });
        }
      },
      modifyManager() {
        const result = window.confirm('수정 시 대표만 커뮤니티 개요, 운영자를 수정하실 수 있습니다. 변경하시겠습니까?');
        if (result) {
          const Params = {
            representation: this.representation,
            manager: this.operatorManager,
          };
          Axios.put(`/api/communities/${this.selectedId}/manager`,
            Params,
            { params: { org: this.communityInfo.org },
            }).then(() => {
            alert('변경되었습니다.');
            location.reload();
          }).catch((e) => {
            alert(e.response.data.msg);
          });
        }
      },
    },
    mounted() {
      this.getParams();
      this.getCommunityInfo();
    },
  };
</script>


// WEBPACK FOOTER //
// MypageCommunityInfo.vue?3a9cb332